import { KillSwitchModule } from "@/types/module-kill-switch";

type ModuleEffectItems = {
  disabled: readonly string[];
  notDisabled: readonly string[];
};

export const MODULE_EFFECT_ITEMS: Record<KillSwitchModule, ModuleEffectItems> =
  {
    PAYMENTS: {
      disabled: [
        "modules.effects.PAYMENTS.disabled.item1",
        "modules.effects.PAYMENTS.disabled.item2",
        "modules.effects.PAYMENTS.disabled.item3",
        "modules.effects.PAYMENTS.disabled.item4",
        "modules.effects.PAYMENTS.disabled.item5",
        "modules.effects.PAYMENTS.disabled.item6",
      ],
      notDisabled: [
        "modules.effects.PAYMENTS.notDisabled.item1",
        "modules.effects.PAYMENTS.notDisabled.item2",
        "modules.effects.PAYMENTS.notDisabled.item3",
      ],
    },
    PMS: {
      disabled: [
        "modules.effects.PMS.disabled.item1",
        "modules.effects.PMS.disabled.item2",
        "modules.effects.PMS.disabled.item3",
        "modules.effects.PMS.disabled.item4",
      ],
      notDisabled: [
        "modules.effects.PMS.notDisabled.item1",
        "modules.effects.PMS.notDisabled.item2",
      ],
    },
    PARTNERS: {
      disabled: [
        "modules.effects.PARTNERS.disabled.item1",
        "modules.effects.PARTNERS.disabled.item2",
        "modules.effects.PARTNERS.disabled.item3",
      ],
      notDisabled: [
        "modules.effects.PARTNERS.notDisabled.item1",
        "modules.effects.PARTNERS.notDisabled.item2",
        "modules.effects.PARTNERS.notDisabled.item3",
      ],
    },
    COMMUNICATION_CHANNELS: {
      disabled: [
        "modules.effects.COMMUNICATION_CHANNELS.disabled.item1",
        "modules.effects.COMMUNICATION_CHANNELS.disabled.item2",
        "modules.effects.COMMUNICATION_CHANNELS.disabled.item3",
        "modules.effects.COMMUNICATION_CHANNELS.disabled.item4",
      ],
      notDisabled: [
        "modules.effects.COMMUNICATION_CHANNELS.notDisabled.item1",
        "modules.effects.COMMUNICATION_CHANNELS.notDisabled.item2",
        "modules.effects.COMMUNICATION_CHANNELS.notDisabled.item3",
      ],
    },
    WHATSAPP: {
      disabled: [
        "modules.effects.WHATSAPP.disabled.item1",
        "modules.effects.WHATSAPP.disabled.item2",
        "modules.effects.WHATSAPP.disabled.item3",
        "modules.effects.WHATSAPP.disabled.item4",
      ],
      notDisabled: [
        "modules.effects.WHATSAPP.notDisabled.item1",
        "modules.effects.WHATSAPP.notDisabled.item2",
        "modules.effects.WHATSAPP.notDisabled.item3",
      ],
    },
  };
